import type { ReactNode } from "react";

interface PreviewCanvasScaleProps {
  testId: string;
  children: ReactNode;
}

/**
 * Scales a 391×291 Figma canvas to fit the compact 243×181 preview shell.
 * Responds to the tool card `@container` — 1:1 from `@lg` (512px card width).
 */
export function PreviewCanvasScale({
  testId,
  children,
}: PreviewCanvasScaleProps) {
  return (
    <div className="relative h-full w-full overflow-hidden">
      <div
        data-testid={testId}
        className="absolute top-0 left-0 h-[291px] w-[391px] origin-top-left scale-[0.622] @lg:scale-100"
      >
        {children}
      </div>
    </div>
  );
}
